import type { SpaceId } from '@respaldos/shared';

export interface SpaceMetaBannerPart {
  strong?: string;
  code?: string;
  text?: string;
}

export interface SpaceMeta {
  crumbs: string[];
  banner: { parts: SpaceMetaBannerPart[] };
  status: string;
  uploadTitle: string;
  uploadNote: string;
  readOnly: boolean;
  technical?: boolean;
}

/** Friendly labels only — never s3:// or bucket names for Marketing. */
export function spaceMeta(spaceId: SpaceId, currentRelPath = ''): SpaceMeta {
  const pathCrumbs = currentRelPath
    .split('/')
    .map((s) => s.trim())
    .filter(Boolean);

  switch (spaceId) {
    case 'marketing':
      return {
        crumbs: ['Marketing', ...pathCrumbs],
        banner: {
          parts: [
            { strong: 'Espacio Marketing' },
            { text: 'Archivos de la agencia' },
            { text: 'Los archivos antiguos pasan a archivo frío automáticamente' },
          ],
        },
        status: 'Marketing · carpeta actual',
        uploadTitle: 'Subir a Marketing',
        uploadNote:
          'Los archivos se guardan en la carpeta actual. Puede seguir el progreso de la subida en la barra superior.',
        readOnly: false,
        technical: false,
      };
    case 'bo':
      return {
        crumbs: ['Respaldos · Bolivia', 'db', ...pathCrumbs],
        banner: {
          parts: [
            { strong: 'Respaldos Bolivia' },
            { text: 'Principalmente lectura · Subidas del Agente SQL' },
            { text: 'Nivel: Archivo profundo' },
          ],
        },
        status: 'Respaldos · Bolivia',
        uploadTitle: 'Subir a Respaldos · BO',
        uploadNote: 'Espacio de solo lectura · administrado por el agente SQL',
        readOnly: true,
        technical: true,
      };
    case 'pe':
      return {
        crumbs: ['Respaldos · Perú', 'db', ...pathCrumbs],
        banner: {
          parts: [
            { strong: 'Respaldos Perú' },
            { text: 'Principalmente lectura · Subidas del Agente SQL' },
          ],
        },
        status: 'Respaldos · Perú',
        uploadTitle: 'Subir a Respaldos · PE',
        uploadNote: 'Espacio de solo lectura · administrado por el agente SQL',
        readOnly: true,
        technical: true,
      };
    case 'py':
      return {
        crumbs: ['Respaldos · Paraguay', 'db', ...pathCrumbs],
        banner: {
          parts: [
            { strong: 'Respaldos Paraguay' },
            { text: 'Principalmente lectura · Subidas del Agente SQL' },
          ],
        },
        status: 'Respaldos · Paraguay',
        uploadTitle: 'Subir a Respaldos · PY',
        uploadNote: 'Espacio de solo lectura · administrado por el agente SQL',
        readOnly: true,
        technical: true,
      };
  }
}

export function isPreviewable(file: { type: string; name: string; isFolder: boolean }): boolean {
  if (file.isFolder) return false;
  if (file.type === 'image' || file.type === 'video' || file.type === 'pdf') return true;
  const lower = file.name.toLowerCase();
  return /\.(png|jpe?g|gif|webp|svg|mp4|webm|mov|pdf)$/i.test(lower);
}
